import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    ChangeDetectionStrategy
} from "@angular/core";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { NgClass } from "@angular/common";

@Component({
    selector: "rask-inline-toast",
    templateUrl: "./inline-toast.component.html",
    styleUrls: ["./inline-toast.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class InlineToastComponent implements OnInit, OnDestroy {

    @Input() viewInMillisseconds: number;
    @Input() toastMessage: string;
    @Input() showToast: Observable<unknown>;

    protected toastVisible = false;

    private timerId = undefined;

    private readonly ngUnsubscribe$ = new Subject<void>();

    ngOnInit(): void {
        this.showToast
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(() => this.viewToast());
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    private viewToast() {
        this.toastVisible = true;
        clearTimeout(this.timerId);
        this.timerId = setTimeout(() => {
            this.toastVisible = false;
            this.timerId = undefined;
        }, this.viewInMillisseconds);
    }

}
